import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import IndulgeInInnovation from "./sections/IndulgeInInnovation";
import TheViralityEngine from "./sections/TheViralityEngine";
import ImpactInNumbers from "./sections/ImpactInNumbers";
import WhyNationalUpvc from "./sections/WhyNationalUpvc";
import SuccessStories from "./sections/SuccessStories";
import InitiateLogistics from "./sections/InitiateLogistics";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <IndulgeInInnovation />
      <TheViralityEngine />
      <ImpactInNumbers />
      <WhyNationalUpvc />
      <SuccessStories />
      <InitiateLogistics />
      <Footer />
    </div>;
}